import Tooltip, { tooltipStyles } from "../tooltips/tooltip";

export const infoIconStyles = {
  tooltip: tooltipStyles,
  svg: "flex fill-secondary bg-greenGlass hover:bg-primary rounded p-1 cursor-pointer shadow-sm shadow-black backdrop-blur-sm",
};

const InfoIcon = ({ text, classNames = infoIconStyles, tooltipPosition }) => {
  return (
    <Tooltip
      classNames={classNames?.tooltip || infoIconStyles.tooltip}
      position={tooltipPosition}
      text={text}
    >
      <svg
        className={classNames?.svg || infoIconStyles.svg}
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 -960 960 960"
        width="24px"
        fill="#e8eaed"
      >
        <path d="M480-680q-33 0-56.5-23.5T400-760q0-33 23.5-56.5T480-840q33 0 56.5 23.5T560-760q0 33-23.5 56.5T480-680Zm-60 560v-480h120v480H420Z" />
      </svg>
    </Tooltip>
  );
};

export default InfoIcon;
